/**
 * @fileoverview Shared constants for the bulk inspection domain.
 * @module inspection/bulkInspectionConstants
 *
 * Responsibilities:
 *   - Single source of truth for the data-bound token prefix used in pilot
 *     response substitution across mobile-pwa and tenant-web.
 *
 * Dependencies: none (pure constants).
 *
 * Architecture:
 *   - Consumed by mobile-pwa bulkInspectionService, BulkPilotFormSession,
 *     and tenant-web bulkInspectionScheduleService / inspectionBulkCompletionService.
 *
 * Notes:
 *   - Token format: `__DB__:<dataSource>:<dotPath>` (e.g. `__DB__:inspectableEntity:address.street1`).
 *   - Mobile and tenant-web currently have divergent token substitution implementations.
 *     This will be revisited when the "bypass pilot form" feature unifies the two paths.
 */

/**
 * Prefix that identifies entity-bound placeholder tokens in pilot form responses.
 *
 * Tokens follow the pattern `__DB__:<dataSource>:<dotPath>` and are replaced
 * with real entity/case values at case-creation time.
 */
export const DB_TOKEN_PREFIX = '__DB__:' as const;
